import CurrenciesStorage from "../storage/currencies-storage";

export default function reducer(state = new CurrenciesStorage(), action) {
  switch (action.type) {
    case "CURRENCIES_SET_DATA": {
      let newState = new CurrenciesStorage({ ...state });
      newState.setAll(action.payload.basedata);
      newState.setAvailable(action.payload.listeSorte, action.payload.timeStampSortenLieferung);
      return newState;
    }
    case "CURRENCIES_SET_LIST_DATA": {
      let newState = new CurrenciesStorage({ ...state });
      newState.setAvailable(action.payload.listeSorte, action.payload.timeStampSortenLieferung);
      return newState;
    }
    case "CURRENCIES_SET_BASE_DATA": {
      let newState = new CurrenciesStorage({ ...state });
      newState.setAll(action.payload.basedata);
      return newState;
    }
    case "CURRENCIES_RESET_DATA": {
      let newState = new CurrenciesStorage({ ...state });
      return newState;
    }
    default:
      return state;
  }
}
